import React, { useState, useEffect } from "react";
import { Table, Spinner, Alert } from "react-bootstrap";
import { Pegar_boletim } from "../../services/api";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

function AbreviarComTooltip({ texto, maxLength }) {
    const [shouldAbbreviate, setShouldAbbreviate] = useState(false);

    // Detecta se a tela tem largura menor ou igual a 576px (ponto de interrupção Bootstrap para dispositivos móveis)
    const isMobile = useMediaQuery({ maxWidth: 576 });

    useEffect(() => {
        setShouldAbbreviate(isMobile);
    }, [isMobile]);

    const abreviarString = (texto, maxLength) => {
        if (texto.length <= maxLength || !shouldAbbreviate) {
            return texto;
        }
        return texto.slice(0, maxLength - 3) + '...';
    };

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">{texto}</Tooltip>}
            trigger={['hover', 'focus', 'click']}
        >
            <span>{abreviarString(texto, maxLength)}</span>
        </OverlayTrigger>
    );
}


const ModuloCiclo = ({ ciclo, matricula, ano }) => {
    const [dadosAgrupados, setDadosAgrupados] = useState({});
    const [loading, setLoading] = useState(true);

    // Ordem estrita definida pelo pedagógico
    const colunasObrigatorias = ["AS", "AP", "AV", "AQ"];

    useEffect(() => {
        const buscarNotas = async () => {
            setLoading(true);
            try {
                console.log(`Buscando notas para matrícula: ${matricula}, ciclo: ${ciclo}, ano: ${ano}`);
                const response = await Pegar_boletim(matricula, ciclo, ano);
                const rawData = response.data;
                console.log("Notas brutas recebidas:", rawData);

                const agrupado = {};

                rawData.forEach(item => {
                    const siglaCompleta = item.avaliacao_sigla.toUpperCase();
                    // Extrai apenas as letras da sigla (ex: AS1 -> AS, AP1 -> AP)
                    const siglaBase = siglaCompleta.replace(/[0-9]/g, '');

                    // Mantém o filtro de ocultar AB e AC
                    if (siglaBase === "AB" || siglaBase === "AC") {
                        return;
                    }

                    if (!agrupado[item.nome_disciplina]) {
                        agrupado[item.nome_disciplina] = {};
                    }

                    // Armazenamos a nota associada à sigla base (AS, AP, etc)
                    agrupado[item.nome_disciplina][siglaBase] = item.nota_final;
                });

                setDadosAgrupados(agrupado);
            } catch (error) {
                console.error("Erro ao buscar notas do ciclo:", error);
            } finally {
                setLoading(false);
            }
        };

        buscarNotas();
    }, [ciclo, matricula, ano]);

    // Função para converter a string da nota (ex: "07,5") em número para cálculo
    const converterParaNumero = (valor) => {
        if (!valor) return 0;
        const limpo = valor.toString().replace(',', '.').trim();
        const num = parseFloat(limpo);
        return isNaN(num) ? 0 : num;
    };

    const formatarExibicao = (valor) => {
        const num = converterParaNumero(valor);
        if (num === 0) return "-";
        return valor; // Retorna o formato original (ex: "07,5") para exibição
    };

    const calcularSoma = (notasDisciplina) => {
        const soma = colunasObrigatorias.reduce((acc, sigla) => {
            return acc + converterParaNumero(notasDisciplina[sigla]);
        }, 0);

        return soma === 0 ? "-" : soma.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    };

    if (loading) return <div className="text-center p-4"><Spinner animation="border" variant="primary" /></div>;

    if (Object.keys(dadosAgrupados).length === 0) {
        return <Alert variant="info" className="mt-3">Aguardando liberação das notas pela secretaria.</Alert>;
    }

    return (
        <div className="table-responsive">
            <Table striped bordered hover size="sm" className="mt-3">
                <thead className="table-dark text-center">
                    <tr>
                        <th className="text-start"><AbreviarComTooltip texto="Disciplina" maxLength={6} /></th>
                        {colunasObrigatorias.map(sigla => (
                            <th key={sigla} style={{ width: '80px' }}>{sigla}</th>
                        ))}
                        <th style={{ width: '100px', backgroundColor: '#495057' }}>CICLO</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(dadosAgrupados).sort().map(disci => (
                        <tr key={disci}>
                            <td style={{ fontWeight: '500' }}><AbreviarComTooltip texto={disci} maxLength={6} /></td>
                            {colunasObrigatorias.map(sigla => (
                                <td key={sigla} className="text-center">
                                    {formatarExibicao(dadosAgrupados[disci][sigla])}
                                </td>
                            ))}
                            <td className="text-center" style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                {calcularSoma(dadosAgrupados[disci])}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default ModuloCiclo;